module.exports = __webpack_public_path__ + "img/wuliuflow.6bbcd1ea.png";